export default __webpack_public_path__ + "static/media/detail_big_9_1.f15b84be.jpg";